// extracted by mini-css-extract-plugin
export default {"LiveMatches":"LiveMatches_LiveMatches__519vQ","matchRow":"LiveMatches_matchRow__kuRA2"};